import { MsgStatus } from '../integrations/sendDataBase.data';
import { MsgQueueBase } from './messageQueue.data';

export enum EmailTemplateType {
  CONCIERGE = 'concierge',
  EXTERNAL_CONCIERGE = 'externalConcierge',
  DEFECT = 'defect',
  QR_DEFECT_CONFIRMATION = 'qrDefectConfirmation',
  QR_DEFECT_FIXED = 'qrDefectFixed',
  WWW_DEFECT_CONFIRMATION = 'wwwDefectConfirmation',
  WWW_DEFECT_FIXED = 'wwwDefectFixed',
  ISSUE = 'issue',
  NEWS = 'news',
  // DEVELOPER_DEFECT = 'devDefect',
  ACTIVATE_WEB = 'activateWeb',
  ACTIVATE_MOBILE = 'activateMobile',
  RESET_PASSWORD = 'resetPassword',
  REVIEW = 'review',
  SUBCONTRACTOR = 'subcontractor',
  AGREEMENT = 'agreement',
  EMPTY = 'empty',
  ADD_POLL = 'addPoll',
  PUBLISH_POLL = 'publishPoll',
  REMIND_POLL = 'remindPoll',
  UTILITY = 'utility',
  RENOVATION = 'renovation',
  INSURANCE = 'insurance',
  SSO_ACCESS_REQUEST = 'ssoAccessRequest',
  CUSTOM = 'custom'
}

export type ExternDefectEmailTemplateType =
  | EmailTemplateType.QR_DEFECT_CONFIRMATION
  | EmailTemplateType.QR_DEFECT_FIXED
  | EmailTemplateType.WWW_DEFECT_CONFIRMATION
  | EmailTemplateType.WWW_DEFECT_FIXED;

export interface EmailQueueData extends MsgQueueBase<MsgStatus> {
  processingStartDate?: number;
  templateType: EmailTemplateType;
  /** separated by "," */
  emailFor: string;
  senderEmail: string;

  subject: string;
  message: string;
  attachmentsUrls: string;
  additionalData: {
    defectId?: string;
    conciergeId?: string;
    residentIssueId?: string;
    newsId?: string;
    pollId?: string;
    publicStatusCode?: string;
    conversationId?: string;
  };
}

/** @deprecated use EmailQueueData instead */
export type EmailQueueObj = EmailQueueData;
